export default __webpack_public_path__ + "static/media/ambio-logo.e048638d.svg";